import './ConfirmationDialog-87ccf595.css';

var classes = {"ConfirmationHeader":"prc-ConfirmationDialog-ConfirmationHeader-yiLEc","ConfirmationBody":"prc-ConfirmationDialog-ConfirmationBody-ht9P-","ConfirmationFooter":"prc-ConfirmationDialog-ConfirmationFooter-AqKBI"};

export { classes as default };
